import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { cn } from "@/lib/utils";
import type { LibraryFolder } from "@/services/foldersService";

export function DroppableLibraryFolder({
  folder,
  children,
}: {
  folder: LibraryFolder;
  children: React.ReactElement;
}) {
  const { setNodeRef, isOver } = useDroppable({
    id: `droppable-${folder.id}`,
    data: { folderId: folder.id },
  });
  return React.cloneElement(React.Children.only(children), {
    ref: setNodeRef,
    className: cn(
      children.props.className,
      isOver && "ring-2 ring-primary ring-offset-2 bg-amber-100/80 dark:bg-amber-900/40"
    ),
  });
}

export function DroppableLibrarySpace({
  spaceId,
  children,
}: {
  spaceId: string;
  children: React.ReactElement;
}) {
  const { setNodeRef, isOver } = useDroppable({
    id: `droppable-space-${spaceId}`,
    data: { spaceId },
  });
  return React.cloneElement(React.Children.only(children), {
    ref: setNodeRef,
    className: cn(
      children.props.className,
      isOver && "ring-2 ring-primary ring-offset-2 bg-purple-100/80 dark:bg-purple-900/40"
    ),
  });
}
